import React from 'react';
import { TrendIcon } from './helper';
import FieldIcon from '../../b2b-common/FieldIcon';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const Trend = ({ trend, className = null, showLabel = true, withTooltip = true }) => {
    const { t } = useB2BTranslation('b2b-plans');
    return (
        <FieldIcon label={showLabel ? t('Trend') : null} icon={<TrendIcon trend={trend} withTooltip={withTooltip} />} className={className} />
    );
};

export default Trend;